var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    [
      _c(
        "v-btn",
        {
          attrs: { "x-large": "", block: "", color: "accent" },
          on: {
            click: function($event) {
              return _vm.$refs.dialog.show()
            }
          }
        },
        [
          _c("v-icon", { attrs: { left: "", large: "" } }, [
            _vm._v("cci-accuracy")
          ]),
          _vm._v("\n    Add New Pilot\n  ")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "cc-solo-dialog",
        {
          ref: "dialog",
          attrs: {
            icon: "cci-pilot",
            "no-confirm": "",
            large: "",
            title: "Register Pilot"
          }
        },
        [
          _c(
            "v-container",
            [
              _c("new-pilot-button"),
              _vm._v(" "),
              _c(
                "v-row",
                [
                  _c("file-import", {
                    on: {
                      done: function($event) {
                        return _vm.$refs.dialog.hide()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("cloud-import", {
                    on: {
                      done: function($event) {
                        return _vm.$refs.dialog.hide()
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("v-row")
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }